var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'is-mobile': _vm.is.mobile, 'is-tablet': _vm.is.tablet},attrs:{"id":"app"}},[(!_vm.is.loading)?[_c('com-logo'),_c('com-metrics',{attrs:{"data":_vm.data}}),_c('com-chart-syncs',{attrs:{"data":_vm.data,"width":_vm.width}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }